import { useQuery } from 'react-query';

import { getGoogleToken } from '@/services/api';
import { logger } from '@/services/logger';

export default function () {
    return useQuery('get-google-key', getGoogleToken, {
        staleTime: 1000 * 60 * 5,
        onError: error => {
            logger.error('Could not fetch tts data', { error });
        },
    });
}
